export type TokenClaims = {
  /** Active organization id, or null when the token has none. */
  tid: number | null
  /** Organizations the operator may switch into. */
  tids: number[]
}

const EMPTY_CLAIMS: TokenClaims = { tid: null, tids: [] }

/** Decodes JWT claims without verifying — drives UI decisions only. */
export const getTokenClaims = (token: string | null): TokenClaims => {
  const payload = token?.split('.')[1]
  if (!payload) return EMPTY_CLAIMS

  try {
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
    const decoded = JSON.parse(atob(base64)) as Record<string, unknown>
    const tid = typeof decoded.tid === 'number' ? decoded.tid : null
    const tids = Array.isArray(decoded.tids)
      ? decoded.tids.filter((t): t is number => typeof t === 'number')
      : []
    return { tid, tids }
  } catch {
    return EMPTY_CLAIMS
  }
}
